import { trigger, state, style, animate, transition } from '@angular/animations';

export const fadeInOut = trigger('fadeInOut', [
  state(
    'void',
    style({
      opacity: 0,
    })
  ),
  transition(':enter, :leave', [animate('0.5s ease-in-out')]),
]);

export const slideInOut = trigger('slideInOut', [
  state('in', style({ transform: 'translateX(0)', opacity: 1 })),
  state('out', style({ transform: 'translateX(-100%)', opacity: 0 })),
  transition('in => out', animate('300ms ease-in-out')),
  transition('out => in', animate('300ms ease-in-out')),
]);

export const slideInOutbtn = trigger('slideInOutbtn', [
  state('in', style({ transform: 'translateX(-4rem)' })),
  state('out', style({ transform: 'translateX(-23rem)' })),
  transition('in => out', animate('300ms ease-in-out')),
  transition('out => in', animate('300ms ease-in-out')),
]);